import styles from './DialogPopup.module.scss'
import {FloatingFocusManager} from '@floating-ui/react'
import React, {type ReactNode} from 'react'
import {useDialogContext} from '../Root/DialogRootContext.ts'
import clsx from 'clsx'

interface DialogPopupProps {
    className?: string
    children?: ReactNode
}

export function DialogPopup({
    className,
    children,
}: DialogPopupProps) {
    const {context} = useDialogContext()

    return (
        <FloatingFocusManager context={context}>
            <div className={clsx(styles.popup, className)}>
                {children}
            </div>
        </FloatingFocusManager>
    )
}
